import { useSession } from '@/shared/hooks/use-session';

/**
 * True when the signed-in user is the platform super-admin.
 *
 * The admin rides the same session cookie as a tenant, but the tenant behind it
 * (`kmi-admin`) is a placeholder — it owns no properties, plan, permissions or
 * sibling workspaces. Every tenant-scoped query is therefore dead weight for
 * them: the admin chrome ignores the results (`isAdmin ? 'KMI Admin Platform'
 * : tenant?.name`, `showPlan={!isAdmin}`, admin nav items carry no `feature`),
 * yet each call still costs a full round trip to a remote database and competes
 * for connections with the `/admin/*` request the page actually needs.
 *
 * Use it to switch those queries off via `enabled`.
 */
export function useIsPlatformAdmin(): boolean {
    const { session } = useSession();
    return session?.role === 'super_admin';
}
